export default "__VITE_ASSET__OR_tElJ3__"